import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Component that syncs user data with the server on every page navigation.
 * Must be placed inside the Router but can be anywhere in the component tree.
 */
export function AuthSync() {
  const location = useLocation();
  const { refreshUser, user, isLoading } = useAuth();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    // Skip if no user or still loading
    if (!user || isLoading) return;

    // Only sync if the path actually changed (avoid re-running on other state changes)
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;

    // Sync user data on each page navigation (including impersonated sessions)
    refreshUser().catch(() => {
      // Silently fail - the 401 interceptor handles auth failures
    });
  }, [location.pathname, user, isLoading, refreshUser]);

  return null;
}
